export interface Status {
    value: string;
    label: string;
    color: string;
}

export const ORDER_FILE_STATUSES: Status[] = [
    { value: 'draft', label: 'Draft', color: 'gray' },
    { value: 'submitted', label: 'Submitted', color: 'blue' },
    { value: 'capacity-updated', label: 'Capacity Updated', color: 'processing' },
    { value: 'capacity-rejected', label: 'Capacity Rejected', color: 'red' },
    { value: 'capacity-approved', label: 'Capacity Approved', color: 'green' },
    { value: 'price-checked', label: 'Price Checked', color: 'gold' },
    { value: 'price-rejected', label: 'Price Rejected', color: 'red' },
    { value: 'price-approved', label: 'Price Approved', color: 'green' },
    { value: 'pre-invoice-created', label: 'Pre-Invoice Created', color: 'processing' },
    { value: 'pre-invoice-rejected', label: 'Pre-Invoice Rejected', color: 'red' },
    { value: 'pre-invoice-approved', label: 'Pre-Invoice Approved', color: 'green' },
    { value: 'order-created', label: 'Order Created', color: 'processing' },
    { value: 'order-checked', label: 'Order Checked', color: 'gold' },
    { value: 'invoice-created', label: 'Invoice Created', color: 'processing' },
    { value: 'invoice-rejected', label: 'Invoice Rejected', color: 'red' },
    { value: 'invoice-approved', label: 'Invoice Approved', color: 'green' },
    { value: 'ready-for-shipment', label: 'Ready for Shipment', color: 'cyan' },
    { value: 'shipped', label: 'Shipped', color: 'blue' },
    { value: 'arrived', label: 'Arrived', color: 'green' },
    { value: 'pending-payment', label: 'Pending Payment', color: 'orange' }
];

// Helper functions
export const getStatusLabel = (value: string): string => {
    return ORDER_FILE_STATUSES.find(status => status.value === value)?.label || value;
};

export const getStatusColor = (value: string): string => {
    return ORDER_FILE_STATUSES.find(status => status.value === value)?.color || 'default';
};

export const getStatusOptions = () => {
    return ORDER_FILE_STATUSES.map(status => ({
        value: status.value,
        label: status.label
    }));
};

export const getStatusFilters = () => {
    return ORDER_FILE_STATUSES.map(status => ({
        text: status.label,
        value: status.value
    }));
}; 